import { ObjectMapper } from 'json-object-mapper';
import { Model } from 'services/models/model';
import { IModel } from 'services/models/IModel';
import { RecruitmentCustomFieldItemOptionModel } from './recruitment-custom-field-item-option.model';

export class RecruitmentCustomFieldItemModel
  extends Model
  implements IModel<RecruitmentCustomFieldItemModel>
{
  public recruitmentId: string = '';
  public label: string = '';
  public arquivo: boolean = false;
  public inputType: string = '';
  public placeholder: string = '';
  public description: string = '';
  public parentItemId: string = '';
  public required: boolean = false;
  public order: number = 0;
  public parentItem?: RecruitmentCustomFieldItemModel;
  public itemChildren?: RecruitmentCustomFieldItemModel[] = [];
  public options?: RecruitmentCustomFieldItemOptionModel[] = [];
  public isChild: boolean = false;
  public isUpdate: boolean = false;
  public fullLabel: string = '';

  static create(input: any): RecruitmentCustomFieldItemModel {
    if ('parentItem' in input) {
      input.parentItem = input.parentItem
        ? RecruitmentCustomFieldItemModel.create(input.parentItem)
        : null;
    }

    if ('itemChildren' in input) {
      input.itemChildren = input.itemChildren
        ? input.itemChildren.map(RecruitmentCustomFieldItemModel.create)
        : [];
    }

    if ('options' in input) {
      input.options = input.options
        ? input.options.map(RecruitmentCustomFieldItemOptionModel.create)
        : [];
    }

    return ObjectMapper.deserialize<RecruitmentCustomFieldItemModel>(
      RecruitmentCustomFieldItemModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
